// The QC category taxonomy, shared by the QC page and the monthly PDF report so
// the two can't drift apart. Mirrors CATEGORIES in backend/src/services/qcClassify.js —
// keep the two lists in step when adding a category.

export const CATEGORIES = [
  'No SSR Submitted',
  'Incomplete SSR',
  'Missing Photos',
  'Bore Info/Photos',
  'Missing Points/Features',
  'Point Accuracy/Placement',
  'Storm/Sanitary Mislabel',
  'Wrong Layer/Label',
  'Mapping/Linework',
  'Notes/Typos',
  'Other',
];

export const CAT_COLOR = {
  'No SSR Submitted': '#ef4444',
  'Incomplete SSR': '#f59e0b',
  'Missing Photos': '#ec4899',
  'Bore Info/Photos': '#f97316',
  'Missing Points/Features': '#a855f7',
  'Point Accuracy/Placement': '#06b6d4',
  'Storm/Sanitary Mislabel': '#3b82f6',
  'Wrong Layer/Label': '#84cc16',
  'Mapping/Linework': '#14b8a6',
  'Notes/Typos': '#22c55e',
  Other: '#9ca3af',
};
